import { render, staticRenderFns } from "./RMAOrder.vue?vue&type=template&id=001509d2&scoped=true&"
import script from "./RMAOrder.vue?vue&type=script&lang=js&"
export * from "./RMAOrder.vue?vue&type=script&lang=js&"
import style0 from "./RMAOrder.vue?vue&type=style&index=0&id=001509d2&scoped=true&lang=css&"
import style1 from "./RMAOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001509d2",
  null
  
)

export default component.exports